
<div>
  <b-container style="margin-top: 70px">
    <b-row>
      <b-col>
        <b-card no-body>
          <b-card-header>
            <h5>Part Search</h5>
          </b-card-header>
          <b-card-body>
            <b-form class="mb-3">
              <b-container fluid>
                <b-row>
                  <b-col xl="6" lg="6" md="12" sm="12" >
                    <b-form-group label="Part Number(s)" label-class="font-weight-bold">
                      <b-form-textarea v-model="search_form.part_numbers"></b-form-textarea>
                    </b-form-group>
                  </b-col>
                  <b-col xl="6" lg="6" md="12" sm="12" class="d-flex">
                    <b-button variant="primary"  @click="startSearch()" class="align-self-center">
                      Search
                    </b-button>
                    </b-col>
                </b-row>
              </b-container>
            </b-form>
            <b-alert
              v-if="save_errors.length > 0"
              variant="danger"
              show
              dismissible
              @dismissed="save_errors = []"
            >
              Could not add the following part numbers:
              <strong>{{ save_errors.map(e => e.part_number).join(', ') }}</strong>.
              Please try again or contact support.
            </b-alert>
            <b-table
                striped
                hover
                small
                stacked="lg"
                :items="displayItems"
                :fields="fields"
                show-empty
                empty-text="There are no records to show">
              <template v-slot:head(selected)>
                <b-form-checkbox
                  :checked="allSelected"
                  :indeterminate="someSelected"
                  :disabled="saving"
                  @change="toggleSelectAll"
                />
              </template>
              <template v-slot:cell(selected)="data">
                <b-form-checkbox
                  v-if="data.item.status === 'FOUND'"
                  :value="data.item"
                  :disabled="saving"
                  v-model="selected_items"
                />
              </template>
              <template v-slot:cell(part_number)="data">
                {{ data.item.part_number }}
              </template>
              <template v-slot:cell(part_description)="data">
                {{ data.item.part_description }}
              </template>
              <template v-slot:cell(msrp_price)="data">
                {{ formatCurrency(data.item.msrp_price) }}
              </template>
              <template v-slot:cell(breakeven_price)="data">
                {{ formatCurrency(data.item.breakeven_price) }}
              </template>
              <template v-slot:head(action)>
                <div v-if="displayItems.length > 1" class="d-flex align-items-center justify-content-end">
                  <span v-if="saving" class="mr-2 small text-muted text-nowrap">
                    Added {{ save_progress.completed }} of {{ save_progress.total }}
                  </span>
                  <b-dropdown variant="primary" no-caret :disabled="saving" right>
                    <template #button-content>
                      <b-spinner v-if="saving" small />
                      <b-icon-list-check v-else />
                    </template>
                    <b-dropdown-item @click="toggleSelectMode">Select Parts</b-dropdown-item>
                    <b-dropdown-item :disabled="selected_items.length === 0" @click="addSelectedToQuote">
                      Add Selected to Quote ({{ selected_items.length }})
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </template>
              <template v-slot:cell(action)="data">
                <template v-if="data.item.status === 'FOUND'">
                  <b-button variant="primary" :disabled="saving" @click="addToQuote(data.item)" class="text-nowrap">
                    Add to Quote
                  </b-button>
                </template>
                <template v-else>
                  <a href="#" @click.prevent="toggleDetails(data.item)" class="small text-muted">
                    {{ getStatusLabel(data.item.status) }}
                    <span v-if="data.item._showDetails">[-]</span>
                    <span v-else>[+]</span>
                  </a>
                </template>
              </template>
              <template v-slot:row-details="data">
                <div class="p-3 bg-light border-top" style="white-space: pre-line">
                  {{ data.item.message }}
                </div>
              </template>
            </b-table>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </b-container>

  <b-modal
    id="part-number-mismatch-modal"
    title="Part Number Changed"
    no-close-on-backdrop
    hide-header-close
  >
    <template v-if="mismatch">
      <p>
        The part number you searched for
        <strong>{{ mismatch.searched }}</strong>
        was resolved to
        <strong>{{ mismatch.resolved }}</strong>
        due to configuration rules.
      </p>

      <template v-if="mismatch.componentChanges && mismatch.componentChanges.length">
        <p>The following components were changed:</p>
        <b-table-simple small bordered>
          <b-thead>
            <b-tr>
              <b-th>Component</b-th>
              <b-th>Searched</b-th>
              <b-th>Resolved to</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="change in mismatch.componentChanges" :key="change.category">
              <b-td>{{ change.category }}</b-td>
              <b-td>{{ change.from ? change.from.join(', ') : '—' }}</b-td>
              <b-td>{{ change.to   ? change.to.join(', ')   : '—' }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </template>

      <p>
        The item has been added to your quote with the resolved part number.
        You can review the configuration to correct the selection, or continue to your quote.
      </p>
    </template>

    <template #modal-footer>
      <b-button variant="primary" @click="goToConfiguration">
        Review Configuration
      </b-button>
      <b-button variant="outline-secondary" @click="addAnyway">
        Add Anyway
      </b-button>
    </template>
  </b-modal>
</div>
